/** Mapping stratégie → investisseur et fiches investisseurs (enrichissement filtre Philosophie). */

export const STATIC_INVESTORS = {
  "Peter Lynch": {
    ini: "PL",
    style: "GARP",
    bio: "Gérant du Magellan Fund de 1977 à 1990, +29.2%/an. Auteur de 'One Up on Wall Street' (1989).",
    philosophy:
      "GARP — Growth at a Reasonable Price. Il popularisa le ratio PEG pour identifier des croissances sous-évaluées. Investir dans ce qu'on comprend.",
  },
  "Christopher Mayer": {
    ini: "CM",
    style: "Value",
    bio: "Auteur de '100 Baggers' (2015). Gérant chez Woodlock House Family Capital.",
    philosophy:
      "Identifier des entreprises capables de multiplier leur valeur par 100 via un dirigeant-actionnaire aligné et la patience du compounding.",
  },
  "Warren Buffett": {
    ini: "WB",
    style: "Value",
    bio: "PDG de Berkshire Hathaway depuis 1965. Oracle d'Omaha. ~20%/an composé sur 60 ans.",
    philosophy:
      "Acheter de grandes entreprises à prix raisonnable et les conserver indéfiniment. Moat durable, management de grande qualité.",
  },
  "Jim Slater": {
    ini: "JS",
    style: "GARP",
    bio: "Investisseur britannique (1929-2015). Auteur du Zulu Principle (1992). Pionnier du ratio PEG.",
    philosophy: "Small caps sous-recherchées avec PEG < 1, forte croissance bénéficiaire et bilan sain.",
  },
  "Benjamin Graham": {
    ini: "BG",
    style: "Value",
    bio: "Père du value investing (1894-1976). 'Security Analysis' (1934), 'The Intelligent Investor' (1949). Mentor de Buffett.",
    philosophy:
      "Acheter sous la valeur intrinsèque avec une marge de sécurité. Investisseur défensif vs entreprenant.",
  },
  "Joel Greenblatt": {
    ini: "JG",
    style: "Value",
    bio: "Fondateur de Gotham Capital (+40%/an sur 20 ans). Professeur à Columbia. 'The Little Book That Beats the Market' (2005).",
    philosophy:
      "Magic Formula : earnings yield + ROIC pour acheter systématiquement des entreprises rentables sous-valorisées.",
  },
  "Philip Fisher": {
    ini: "PF",
    style: "Growth",
    bio: "Fondateur de Fisher & Company (1931-1999). 'Common Stocks and Uncommon Profits' (1958). Influence reconnue par Buffett.",
    philosophy:
      "Entreprises de croissance avec management visionnaire, R&D solide. Méthode 'scuttlebutt'.",
  },
  "Joseph Piotroski": {
    ini: "JP",
    style: "Value",
    bio: "Professeur à Stanford. F-Score publié en 2000 dans le Journal of Accounting Research.",
    philosophy:
      "F-Score : 9 critères binaires sur rentabilité, endettement et efficacité pour filtrer les value stocks.",
  },
  "James O'Shaughnessy": {
    ini: "JO",
    style: "Quantitative",
    bio: "Auteur de 'What Works on Wall Street' (1996). Fondateur OSAM. Pionnier de l'investissement factoriel.",
    philosophy:
      "Backtests sur 50+ ans pour identifier les facteurs persistants : shareholder yield, momentum, valeur composite.",
  },
  "Mary Buffett": {
    ini: "MB",
    style: "Value",
    bio: "Ancienne belle-fille de Warren Buffett. Co-auteure de 'Buffettology' (1997).",
    philosophy:
      "Durable Competitive Advantage : ROIC élevé, moat protégeant les bénéfices, croissance prévisible.",
  },
  "Seth Klarman": {
    ini: "SK",
    style: "Value",
    bio: "Fondateur de Baupost Group (>30Mds$). 'Margin of Safety' (1991), épuisé >1000$.",
    philosophy: "Marge de sécurité maximale sur actifs tangibles décotés. Protection du capital avant tout.",
  },
  "Charlie Munger": {
    ini: "CM2",
    style: "Value",
    bio: "Vice-Président de Berkshire pendant 50 ans. Décédé en novembre 2023 à 99 ans.",
    philosophy:
      "Modèles mentaux multidisciplinaires. Payer le juste prix pour une entreprise excellente.",
  },
  "George Soros": {
    ini: "GS",
    style: "Macro",
    bio: "Fondateur du Quantum Fund. +1Md$ en shortant la livre sterling en 1992.",
    philosophy: "Réflexivité : perceptions et fondamentaux se co-construisent en boucles exploitables.",
  },
  "Ray Dalio": {
    ini: "RD",
    style: "Macro",
    bio: "Fondateur de Bridgewater Associates (~160Mds$). Auteur de 'Principles'.",
    philosophy:
      "All Weather Portfolio : quatre quadrants croissance/inflation avec actifs non-corrélés.",
  },
  "Michael Burry": {
    ini: "MB2",
    style: "Contrarian",
    bio: "Fondateur de Scion Capital. Shorté les subprimes en 2007-2008 (The Big Short).",
    philosophy: "Deep value bottom-up rigoureux. Agir à contre-courant avec une conviction documentée.",
  },
  "David Dreman": {
    ini: "DD",
    style: "Contrarian",
    bio: "Fondateur de Dreman Value Management. Expert en finance comportementale.",
    philosophy:
      "Les analystes surestiment les valeurs populaires et sous-estiment les délaissées. Acheter bas P/E.",
  },
  "Pat Dorsey": {
    ini: "PD",
    style: "Value",
    bio: "Ex-directeur recherche Morningstar. Fondateur Dorsey Asset Management. 'The Little Book That Builds Wealth'.",
    philosophy: "Economic Moat : réseau, switching cost, avantages de coût, actifs intangibles.",
  },
  "John Templeton": {
    ini: "JT",
    style: "Contrarian",
    bio: "Pionnier de l'investissement international. Fondateur du Templeton Growth Fund en 1954.",
    philosophy:
      "Acheter au point de pessimisme maximum dans le monde entier. Diversification géographique absolue.",
  },
  "Walter Schloss": {
    ini: "WS",
    style: "Value",
    bio: "Élève de Graham. Gérant indépendant pendant 50 ans sans ordinateur. ~15.7%/an.",
    philosophy:
      "Acheter sous la valeur comptable, diversifier sur 100+ titres, ne jamais vendre par impatience.",
  },
  "Howard Marks": {
    ini: "HM",
    style: "Value",
    bio: "Co-fondateur d'Oaktree Capital (~180Mds$). 'The Most Important Thing' et 'Mastering the Market Cycle'.",
    philosophy:
      "Second-level thinking : anticiper ce que le marché anticipe déjà. Risque avant rendement.",
  },
  "Ralph Wanger": {
    ini: "RW",
    style: "Growth",
    bio: "Gérant du Columbia Acorn Fund de 1970 à 2003. 'A Zebra in Lion Country'.",
    philosophy: "Small caps de niche avec croissance bénéficiaire soutenue et management aligné.",
  },
  "Jim Simons": {
    ini: "JS2",
    style: "Quantitative",
    bio: "Fondateur de Renaissance Technologies. Medallion Fund : +66%/an brut sur 30 ans.",
    philosophy:
      "Algorithmes mathématiques sur données massives pour détecter des patterns statistiques non-aléatoires.",
  },
  "Robin Speziale": {
    ini: "RS",
    style: "Quality",
    bio: "Auteur de 'Market Masters' (2016) et 'Capital Compounders' (2018). Investisseur canadien.",
    philosophy:
      "Capital Compounders : entreprises capables de réinvestir leur capital à des taux élevés de manière durable.",
  },
};

export const STATIC_STRAT_INV = {
  "100 Baggers": "Christopher Mayer",
  "100 to 1": "Christopher Mayer",
  "All-Cap Value with Growth Twist": "Peter Lynch",
  "Big Safe Dividends": "James O'Shaughnessy",
  "Buy Good Do Nothing": "Charlie Munger",
  "Contrarian Value": "David Dreman",
  "Deep Value": "Benjamin Graham",
  "Durable Moat": "Pat Dorsey",
  "Global Bargains Hunting": "John Templeton",
  "Low P/E Value Investing": "Benjamin Graham",
  "Magic Formula": "Joel Greenblatt",
  "Market Leaders Low P/CF": "James O'Shaughnessy",
  "Modern Value Investing": "Howard Marks",
  "One Up": "Peter Lynch",
  "Only the Best": "Philip Fisher",
  "Owning the Best": "Warren Buffett",
  "Permanent Portfolio": "Ray Dalio",
  "Piotroski F-Score": "Joseph Piotroski",
  "Quality Growth Investing": "Peter Lynch",
  "Rule 1": "Warren Buffett",
  "Small Cap Value & Growth": "Jim Slater",
  "The Intelligent Investor - Defensive": "Benjamin Graham",
  "The Intelligent Investor - Enterprising": "Benjamin Graham",
  "The Moat": "Warren Buffett",
  "The Zulu Principle": "Jim Slater",
  "Tiny Titans": "James O'Shaughnessy",
  "Value Investing Toolbox - Core": "Benjamin Graham",
  "Value Investing Toolbox - Value": "Walter Schloss",
  "Zebra in Lion Country": "Ralph Wanger",
  "Capital Compounders": "Robin Speziale",
};
